import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { Store } from "./Redux/Store/Store";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { initializeAnalytics } from "./Helper/analytics";
import { initPwaForUser } from "./Helper/pwa";
// import * as Sentry from "@sentry/react";


// Sentry.init({
//   dsn: "https://e05a2061b333192ec3b34c67d50b4389@o4508995178856448.ingest.de.sentry.io/4509031408336976"
// });


const root = ReactDOM.createRoot(document.getElementById("root"));
let client = process.env.REACT_APP_GOOGLE_CLIENT_ID;

initializeAnalytics();
initPwaForUser();

root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId={client}>
      <Provider store={Store}>
        <App />
        <Toaster />
      </Provider>
    </GoogleOAuthProvider>
  //  </React.StrictMode> 
);
reportWebVitals();

